import * as React from 'react';
import { useTranslation } from 'react-i18next';
import FormInput from '../../common/FormInput';
import Selectable from '../../common/Selectable';

const DocumentDetailsPage = ({
    documents,
    onDocumentSelectClick,
    selectedIndex
}): JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            {documents.map((document, index) => (
                <FormInput
                    id='documentdetailspage'
                    label={document.documentType}>
                    <Selectable
                        id={`documentdetails`}
                        onClicked={(selected) =>
                            onDocumentSelectClick(selected, index, document.id)
                        }
                        selected={selectedIndex === index}
                        hasSelectableButton={true}
                        buttonText={t('select')}
                        style={{
                            border: '1px solid #ced4da',
                            marginTop: '10px'
                        }}>
                        <div>
                            <b>{t('document_name')}: </b>
                            <span>{document.fileName}</span>
                        </div>
                    </Selectable>
                </FormInput>
            ))}
        </>
    );
};

export default DocumentDetailsPage;
